import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import notificationPreferencesService from '../../services/notificationPreferencesService';
import { toast } from 'react-hot-toast';

const NotificationPreferences = () => {
  const [prefs, setPrefs] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const res = await notificationPreferencesService.getPreferences();
      setPrefs(res.data || res);
    } catch (e) {
      console.error(e);
      toast.error('Failed to load preferences');
    }
  };

  useEffect(() => { load(); }, []);

  const toggle = (key) => setPrefs((p) => ({ ...p, [key]: !p[key] }));

  const save = async () => {
    try {
      setSaving(true);
      await notificationPreferencesService.updatePreferences(prefs);
      toast.success('Preferences updated');
    } catch (e) {
      console.error(e);
      toast.error('Save failed');
    } finally {
      setSaving(false);
    }
  };

  if (!prefs) return <div className="p-6">Loading...</div>;

  const rows = [
    ['leaveRequests', 'Leave Requests'],
    ['documents', 'Documents'],
    ['announcements', 'Announcements'],
    ['reminders', 'Reminders'],
    ['email', 'Email'],
    ['push', 'Push'],
    ['sms', 'SMS'],
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Notification Preferences</h1>
          <p className="text-gray-600">Choose which notifications you receive and how</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Enabled</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {rows.map(([key, label]) => (
                <tr key={key}>
                  <td className="px-6 py-4">{label}</td>
                  <td className="px-6 py-4">
                    <input type="checkbox" checked={!!prefs[key]} onChange={() => toggle(key)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex justify-end mt-4">
          <button onClick={save} disabled={saving} className="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50">
            {saving ? 'Saving...' : 'Save Preferences'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationPreferences;



